import MatrixGallery_MatrixGalleryDefaultSkinComponent from '../components/NativeGalleries/MatrixGallery/viewer/skinComps/MatrixGalleryDefaultSkin/MatrixGalleryDefaultSkin.skin';
import MatrixGallery_MatrixGalleryDefaultSkinController from '../components/NativeGalleries/MatrixGallery/viewer/MatrixGallery.controller';


const MatrixGallery_MatrixGalleryDefaultSkin = {
  component: MatrixGallery_MatrixGalleryDefaultSkinComponent,
  controller: MatrixGallery_MatrixGalleryDefaultSkinController
};


export const components = {
  ['MatrixGallery_MatrixGalleryDefaultSkin']: MatrixGallery_MatrixGalleryDefaultSkin
};

